import "./selected_application.scss";
import "@/stylesheets/dream_job_icon.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SectionTitle } from "@sprout/typography.tsx";
import { ActivityCard, ActivityProps } from "@components/applications/activity_card.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import ArrowUpIcon from "@sprout/icons/arrow_up.tsx";

interface Props {
  activityHistory: ActivityProps[];
}

const NUM_COLLAPSED = 5;

const ActivityHistory = ({ activityHistory }: Props) => {
  const { t } = useTranslation("applications", { keyPrefix: "activity_history" });
  const [expanded, setExpanded] = useState(false);

  const isExpandable = activityHistory.length > NUM_COLLAPSED;
  const visibleActivities =
    isExpandable && !expanded ? activityHistory.slice(0, NUM_COLLAPSED) : activityHistory;

  return (
    <div>
      {activityHistory.length > 0 && (
        <SectionTitle className="activity-history__title">{t("title")}</SectionTitle>
      )}
      {visibleActivities.map((a) => {
        return <ActivityCard {...a} key={a.type + a.date} />;
      })}
      {isExpandable && (
        <button
          type="button"
          className="link inline-flex items-center gap-1 ml-10"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? t("show_less") : t("show_more")}
          {expanded ? <ArrowUpIcon size="xs" /> : <ArrowDownIcon size="xs" />}
        </button>
      )}
    </div>
  );
};

export default ActivityHistory;
